import { Box } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { IPartnerSearchDataGridProps } from "../../interfaces/PartnerView.interfaces";
import { CustomFeatureRequestList } from "../../SharedComponents/CustomFeatureRequestList";
import { useWindowDimensions } from "../../SharedComponents/useWindowDimensions";
import { FeatureRequestFilterPill } from "./FeatureRequestFilterPill";


export default function FeatureRequestDataGrid({ searchText }: IPartnerSearchDataGridProps) {
  const [filters, setFilters] = useState<any>({});
  const { height } = useWindowDimensions();
  const [filterPillContainerHeight, setFilterPillContainerHeight] = useState(0);
  const filterPillConainerRef = useRef<HTMLDivElement>(null);

  const onPrepareExtraFilter = (props: {
    field: string;
    type: BooleanConstructor | StringConstructor;
    data: string;
  }) => {
    const formFilterPredicate = (value: string) => {
      if (props.type === Boolean) {
        if (value === "1") {
          return `${props.field} eq 1`;
        }
        return `${props.field} eq 0`;
      }
      return `${props.field} eq '${value}'`;
    };
    const formFieldValuePredicate = () => {
      if (props.data) {
        const values = props.data.replace(/;$/, "").split(";");
        if (values.length > 1) {
          return "(" + values.map(formFilterPredicate).join(" or ") + ")";
        } else {
          return values.map(formFilterPredicate).join(" or ");
        }
      }
      return "";
    };

    if (props.data) {
      setFilters((prev: any) => ({
        ...prev,
        [props.field]: formFieldValuePredicate()
      }));
    } else {
      setFilters((prev: any) => {
        const current = { ...prev };
        delete current[props.field];
        return current;
      });
    }
  };
  const filterPillProps = {
    onSourceChange: (data: any) => onPrepareExtraFilter({ data: data, field: columns.source, type: String }),
    onProductNameChange: (data: any) => onPrepareExtraFilter({ data: data, field: columns.productName, type: String }),
    onCustomerFacingStatusChange: (data: any) => onPrepareExtraFilter({ data: data, field: columns.customerFacingStatus, type: String }),
    onPriorityChange: (data: any) => onPrepareExtraFilter({ data: data, field: columns.priority, type: String }),
  };

  useEffect(() => {
    const handleResize = () => {
      setFilterPillContainerHeight(filterPillConainerRef.current?.clientHeight ?? 0);
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <div ref={filterPillConainerRef} style={{ paddingBottom: 18 }}>
        <FeatureRequestFilterPill {...filterPillProps} />
      </div>
      <Box
        sx={{
          width: "100%",
          height: `calc(${height}px - (175px + ${filterPillContainerHeight}px))`
        }}
      >
        <div
          role="tabpanel"
          id="partner-search-grid-tabpanel"
          aria-labelledby="aria-labelledby-partner-search-grid-tabpanel"
          style={{
            height: "100%",
            width: "calc(100% + 10px)"
          }}
        >
          <CustomFeatureRequestList
            initialFilters={Object.values(filters).join(" and ")}
            searchText={searchText}
            skipColumnsFilterable={skipColumnsFilterable}
          />
        </div>
      </Box>
    </>
  );
}

const columns = {
  source: "Source",
  productName: "ProductName",
  customerFacingStatus: "CustomerFacingStatus",
  priority: "Priority"
};

const skipColumnsFilterable: string[] = [ "description"];
